import * as React from "react";

export enum KeyCode {
    ALT = 18,
    UPARROW = 38,
    DOWNARROW = 40,
    LEFTARROW = 37,
    RIGHTARROW = 39,
    ENTER = 13,
    TAB = 9,
    ESC = 27,
    FORWARDSLASH = 191,
    BACKSPACE = 8,
    DELETE = 46,
    HOME = 36,
    END = 35,
    PAGEUP = 33,
    PAGEDOWN = 34,
    ATRATE = 50,
    HASH = 51,
    DOLLAR = 52,
    SHIFT = 16,
    SPACE = 32,
}

const specialChars: Map<number, string> = new Map();
specialChars.set(192, "`");
specialChars.set(189, "-");
specialChars.set(187, "=");
specialChars.set(219, "[");
specialChars.set(221, "]");
specialChars.set(220, "\\");
specialChars.set(186, ";");
specialChars.set(222, "'");
specialChars.set(223, ",");
specialChars.set(190, ".");
specialChars.set(191, "/");
specialChars.set(-192, "~");
specialChars.set(-49, "!");
specialChars.set(-50, "@");
specialChars.set(-51, "#");
specialChars.set(-52, "$");
specialChars.set(-53, "%");
specialChars.set(-54, "^");
specialChars.set(-55, "&");
specialChars.set(-56, "*");
specialChars.set(-57, "(");
specialChars.set(-48, ")");
specialChars.set(-189, "_");
specialChars.set(-187, "+");
specialChars.set(-219, "{");
specialChars.set(-221, "}");
specialChars.set(-220, "|");
specialChars.set(-186, ":");
specialChars.set(-222, '"');
specialChars.set(-188, "<");
specialChars.set(-190, ">");
specialChars.set(-191, "?");

type E = React.KeyboardEvent<HTMLElement>;
export class KeyPress {
    static shiftIsPressed = (e: E) => e.keyCode === KeyCode.SHIFT;
    static altIsPressed = (e: E) => e.keyCode === KeyCode.ALT;
    static enterIsPressed = (e: E) => e.keyCode === KeyCode.ENTER;
    static upArrowIsPressed = (e: E) => e.keyCode === KeyCode.UPARROW;
    static downArrowIsPressed = (e: E) => e.keyCode === KeyCode.DOWNARROW;
    static leftArrowIsPressed = (e: E) => e.keyCode === KeyCode.LEFTARROW;
    static rightArrowIsPressed = (e: E) => e.keyCode === KeyCode.RIGHTARROW;
    static tabIsPressed = (e: E) => e.keyCode === KeyCode.TAB;
    static escIsPressed = (e: E) => e.keyCode === KeyCode.ESC;
    static forwardSlashIsPressed = (e: E) => e.keyCode === KeyCode.FORWARDSLASH;
    static backspaceIsPressed = (e: E) => e.keyCode === KeyCode.BACKSPACE;
    static deleteIsPressed = (e: E) => e.keyCode === KeyCode.DELETE;
    static homeIsPressed = (e: E) => e.keyCode === KeyCode.HOME;
    static endIsPressed = (e: E) => e.keyCode === KeyCode.END;
    static pageUpIsPressed = (e: E) => e.keyCode === KeyCode.PAGEUP;
    static pageDownIsPressed = (e: E) => e.keyCode === KeyCode.PAGEDOWN;
    static attherateIsPressed = (e: E) => e.keyCode === KeyCode.ATRATE;
    static hashIsPressed = (e: E) => e.keyCode === KeyCode.HASH;
    static dollarIsPressed = (e: E) => e.keyCode === KeyCode.DOLLAR;
    static spaceIsPressed = (e: E) => e.keyCode === KeyCode.SPACE;
}

export const isLetterChar = (e: E): string | undefined => {
    if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122)) {
        return String.fromCharCode(e.keyCode);
    } else {
        return undefined;
    }
};

export const isSpecialChar = (e: E, altPressed = true): string | undefined => {
    if (altPressed && specialChars.has(e.keyCode * -1)) {
        return specialChars.get(e.keyCode * -1);
    } else if (specialChars.has(e.keyCode)) {
        return specialChars.get(e.keyCode);
    } else {
        return undefined;
    }
};

export const isDigitChar = (e: E): string | undefined => {
    if (e.keyCode >= 48 && e.keyCode <= 57) {
        return String.fromCharCode(e.keyCode);
    } else {
        return undefined;
    }
};
